module.exports = __webpack_public_path__ + "img/serveone.967660ee.png";